import { render, staticRenderFns } from "./LocalTrainingCreate.vue?vue&type=template&id=e8fde12c&"
import script from "./LocalTrainingCreate.js?vue&type=script&lang=js&"
export * from "./LocalTrainingCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports